<template>
  <div class="simple-pagination">
    <button
      class="simple-pagination__arrow simple-pagination__arrow--prev"
      :disabled="currentPage <= 1"
      @click="goToPrev"
    >
      <
    </button>

    <span class="simple-pagination__info">
      {{ String(currentPage).padStart(2, '0') }} / {{ String(totalPages).padStart(2, '0') }}
    </span>

    <button
      class="simple-pagination__arrow simple-pagination__arrow--next"
      :disabled="currentPage >= totalPages"
      @click="goToNext"
    >
      >
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  currentPage: {
    type: Number,
    default: 1,
  },
  totalPages: {
    type: Number,
    default: 1,
  },
})

const emit = defineEmits(['page-changed'])

const goToPrev = () => {
  if (props.currentPage > 1) {
    emit('page-changed', props.currentPage - 1)
  }
}

const goToNext = () => {
  if (props.currentPage < props.totalPages) {
    emit('page-changed', props.currentPage + 1)
  }
}
</script>

<style lang="scss" scoped>
.simple-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 12px 0;
  border-top: 1px solid #ebebeb;

  &__arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    color: #666;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: color 0.2s ease;

    &:hover:not(:disabled) {
      color: #333;
    }

    &:disabled {
      color: #ccc;
      cursor: not-allowed;
    }

    &--prev {
      // 이전 버튼 스타일
    }

    &--next {
      // 다음 버튼 스타일
    }
  }

  &__info {
    font-size: 14px;
    font-weight: 500;
    color: #666;
    min-width: 60px;
    text-align: center;
  }
}
</style>
